import { LocaleCode } from '@/utils/Locale';

const DEFAULT_LOCALE = 'en';
// 改成你實際的 HubSpot 參數
const DEFAULT_HUBSPOT_PORTAL_ID = '5948150';
const DEFAULT_SRC = 'https://js.hsforms.net/forms/embed/v2.js';
const DEFAULT_REGION = 'na1';

const EN_HUBSPOT_FORM_ID = 'f1908903-749b-476f-82ba-509369f256db';
const DE_HUBSPOT_FORM_ID = '313c9f3d-7537-41d8-9445-5dea1a07e205';
const JP_HUBSPOT_FORM_ID = 'a736ec79-dd6e-4bef-9d97-21ffbe4b579f';
const CN_HUBSPOT_FORM_ID = 'b9571e19-c39c-4c5e-9ffb-575b2b0a821c';
const TW_HUBSPOT_FORM_ID = 'fdd8079c-7860-40e0-a7df-91fb8e676862';

export const HS_FORM_CONTAINER_ID = 'hs-form-contact-us';

export interface HubSpotFormConfig {
    portalId: string;
    formId: string;
    region: string;
    scriptSrc: string;
    containerId: string;
}

/** 統一配置：每個語言一組參數 */
export const HS_FORMS: Record<LocaleCode, HubSpotFormConfig> = {
    en: {
        portalId: DEFAULT_HUBSPOT_PORTAL_ID,
        formId: EN_HUBSPOT_FORM_ID,
        region: DEFAULT_REGION,
        scriptSrc: DEFAULT_SRC,
        containerId: HS_FORM_CONTAINER_ID,
    },
    de: {
        portalId: DEFAULT_HUBSPOT_PORTAL_ID,
        formId: DE_HUBSPOT_FORM_ID,
        region: DEFAULT_REGION,
        scriptSrc: DEFAULT_SRC,
        containerId: HS_FORM_CONTAINER_ID,
    },
    ja: {
        portalId: DEFAULT_HUBSPOT_PORTAL_ID,
        formId: JP_HUBSPOT_FORM_ID,
        region: DEFAULT_REGION,
        scriptSrc: DEFAULT_SRC,
        containerId: HS_FORM_CONTAINER_ID,
    },
    'zh-cn': {
        portalId: DEFAULT_HUBSPOT_PORTAL_ID,
        formId: CN_HUBSPOT_FORM_ID,
        region: DEFAULT_REGION,
        scriptSrc: DEFAULT_SRC,
        containerId: HS_FORM_CONTAINER_ID,
    },
    'zh-tw': {
        portalId: DEFAULT_HUBSPOT_PORTAL_ID,
        formId: TW_HUBSPOT_FORM_ID,
        region: DEFAULT_REGION,
        scriptSrc: DEFAULT_SRC,
        containerId: HS_FORM_CONTAINER_ID,
    },
};

// 取得設定，缺值則回退到預設語言
export function getHsConfig(locale?: string): HubSpotFormConfig {
    const key = (locale ?? DEFAULT_LOCALE) as LocaleCode;
    return HS_FORMS[key] ?? HS_FORMS[DEFAULT_LOCALE];
}
